import { Vue, Component, Prop } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { appConfigService } from '@/providers/services/app/app-config';
import TaxonomyCard from '../taxonomy-card/taxonomy-card';
import { sessionService } from '@/providers/services/auth/session';

@Component({
    name: 'offline-activity-card',
    components: {
        'material-icon': GoogleMaterialIcon,
        'taxonomy-card': TaxonomyCard,
    },
})

export default class OfflineActivityCard extends Vue {
    // ------------------------------------------------------------------------
    // Properties
    @Prop()
    private offlineActivity: any;

    @Prop({default: false})
    private isMyContent!: boolean;

    private get tags() {
        return this.offlineActivity.standards;
    }

    get userId() {
        return sessionService.getSession()!.user_id;
    }

    // --------------------------------------------------------------------
    // Actions
    private onPlayCollection(collectionId: string) {
        const playerURL = `${window.location.origin}/library/player-offline-activity/${collectionId}?isPreview=true&role=teacher&source=rgo`;
        this.$emit('onOpenPlayer', playerURL);
    }

    private openPullout() {
        this.$emit('openPullout', this.offlineActivity);
    }

    private editActivity(collectionId: string) {
        const currentRoute = this.$router.currentRoute.path;
        const playerURL = `${window.location.origin}/library/content/activity/edit/${collectionId}?editingContent=true&isFromOA=true&redirectUrl=${currentRoute}`;
        window.location.href = playerURL;
    }

    private filterCreator(creator: any) {
        this.$emit('filterCreator', creator);
    }
}
